import { render, staticRenderFns } from "./OrcamentoHead.vue?vue&type=template&id=13d73870&scoped=true"
import script from "./OrcamentoHead.vue?vue&type=script&lang=js"
export * from "./OrcamentoHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d73870",
  null
  
)

export default component.exports